import * as React from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import CssBaseline from "@mui/material/CssBaseline";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom/dist";

// import { useLocation } from 'react-router-dom';

import logo from "../img/icon-512x512.png";
import { LoginForm } from "../components/form/forms/login";
import { useLoginMutation } from "../features/auth/authApiSlice";
import { selectCurrentUser } from "../features/auth/authSlice";
import usePersist from "../hooks/usePersist";
import Loading from "../components/spinners/Loading";
import "./LoginPage.css";
import Copyright from "../components/copyright/Copyright";

export default function LoginPage() {
  const [persist, setPersist] = usePersist();
  const { handleSubmit, control } = useForm({
    defaultValues: { mail: "", password: "", stayLoggedIn: persist },
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [loginFeedback, setLoginFeedback] = useState(null);
  const [login, { isLoading }] = useLoginMutation();
  const user = useSelector(selectCurrentUser);
  const from = location.state?.from?.pathname || "/";

  const handleLogin = async (formValue) => {
    const { mail, password, stayLoggedIn } = formValue;
    setPersist(stayLoggedIn);
    setLoginFeedback(null);

    try {
      await login({ mail, password, stayLoggedIn }).unwrap();
      navigate(from, { replace: true });
    } catch (err) {
      const status = err?.originalStatus || err?.status;
      if (status === 401) {
        setLoginFeedback({
          severity: "warning",
          title: "Anmeldedaten stimmen nicht",
          message:
            "Die eingegebene E-Mail-Adresse oder das Passwort ist falsch. Bitte prüfen Sie Ihre Eingaben und versuchen Sie es erneut.",
        });
        return;
      }

      if (status === 400) {
        setLoginFeedback({
          severity: "info",
          title: "Unvollständige Angaben",
          message:
            "Bitte geben Sie Ihre E-Mail-Adresse und Ihr Passwort ein.",
        });
        return;
      }

      setLoginFeedback({
        severity: "error",
        title: "Anmeldung derzeit nicht möglich",
        message:
          "Es ist ein technisches Problem aufgetreten. Bitte versuchen Sie es in wenigen Minuten erneut.",
      });
    }
  };

  const onSubmit = (data) => {
    handleLogin(data);
  };

  if (user) {
    return <Navigate to="/dashboard" />;
  }

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Grid container component="main" sx={{ height: "100vh" }}>
      <CssBaseline />
      <Grid
        item
        xs={false}
        sm={2}
        md={5}
        sx={{
          backgroundImage: "url(/assets/images/stone_sahbumnim.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundColor: (t) =>
            t.palette.mode === "light"
              ? t.palette.grey[50]
              : t.palette.grey[900],
          backgroundSize: "cover",
          backgroundPosition: "25% 70%;",
        }}
      />
      <Grid item xs={12} sm={10} md={7} component={Paper} elevation={6} square>
        <Box
          sx={{
            mt: 12,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <p
            style={{
              color: "black",
              fontFamily: "Aldrich",
              fontSize: 22,
              textDecoration: "none",
              whiteSpace: "normal",
              margin: 0,
            }}
          >
            MARTIAL
          </p>
          <img className="login__logo" src={logo} alt="Logo" />
          <p
            style={{
              color: "black",
              fontFamily: "Aldrich",
              fontSize: 22,
              textDecoration: "none",
              whiteSpace: "normal",
              margin: 0,
            }}
          >
            ARTMINISTRATION
          </p>
          <Typography margin={2} align="center" variant="h4" gutterBottom>
            ANMELDEN
          </Typography>
          <Box textAlign={"center"} style={{ maxWidth: 500 }} sx={{ mt: 1 }}>
            <LoginForm
              onSubmit={() => handleSubmit(onSubmit)}
              control={control}
            />
            {loginFeedback && (
              <Alert
                severity={loginFeedback.severity}
                variant="filled"
                sx={{ my: 2, textAlign: "left", borderRadius: 2 }}
              >
                <AlertTitle sx={{ mb: 0.5 }}>{loginFeedback.title}</AlertTitle>
                {loginFeedback.message}
              </Alert>
            )}

            <Grid container>
              <Grid item xs={12}>
                <Typography variant="h6" sx={{ mt: 1 }}>
                  Sind Sie Inhaber oder Schulleiter und benötigen einen Account? {""}
                  <Link href="register" variant="h6">
                    Hier registrieren
                  </Link>
                </Typography>
              </Grid>
            </Grid>
            <Copyright sx={{ mt: 3 }} />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
